import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../header/header";
import Card from "../../../../components/card/card";
import Footer from "../../../footer/footer";
import { routerPath } from "../../../../navigation/path";
import Skeleton from "../../component/skeleton";
import { dashboardDetail } from "../../service";
import CustomCarousel from "../../component/carousel";
import { useDispatch } from "react-redux";
import {
  updateCategory,
  updateTotalSavings,
} from "../../../../../store/slices/categorySlice";

const Home = () => {
  const [dashboardData, setDashboardData] = useState({});
  const [bannerData, setBannerData] = useState({});
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cardClick = (data) => {
    console.log("card clicked");
    navigate(routerPath.offer, { data: data });
  };

  useEffect(() => {
    getDashboardData();
    // getBannerData()
  }, []);

  const getDashboardData = async () => {
    console.log("Dads");
    try {
      setLoading(true);
      const res = await dashboardDetail();
      setLoading(false);
      await setDashboardData(res.data);
      await dispatch(updateCategory([...res.data.category]));
      await dispatch(updateTotalSavings(res.total_saving));
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const offerClick = (data) => {
    console.log(data);
    navigate(`${routerPath.claimOffer}?offer_id=${data.id}`);
  };

  const categoryClick = (data) => {
    navigate(`${routerPath.offer}?category_id=${data.id}`);
  };

  return (
    <>
      <div>
        <Header />
        <div className="container mx-auto max-w-7xl px-4">
          <CustomCarousel images={dashboardData?.banner} />
          {/* <img src={dashboardData?.image} alt="" /> */}
        </div>
        <div className="container mx-auto max-w-7xl px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 py-10 gap-2 lg:gap-4">
            {dashboardData?.category &&
              dashboardData?.category
                .map((e, i) => (
                  <div className="px-2 overflow-hidden" key={e?.id}>
                    <Card
                      cardType="insideHeading"
                      img={e?.image}
                      title={e?.name}
                      click={() => categoryClick(e)}
                    />
                  </div>
                ))
                .slice(0, 5)}
            {isLoading &&
              [1, 2, 3, 4, 5].map((e, i) => (
                <div className="px-2 overflow-hidden py-2" key={e}>
                  <Skeleton />
                </div>
              ))}
          </div>
          <div>
            <div>
              <h4 className="mb-0 px-3 font-bold">Offers from Top Brands</h4>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 py-3 gap-2">
              {dashboardData.get_offer_top_brand &&
                dashboardData.get_offer_top_brand
                  .map((e, i) => (
                    <div className="px-2 overflow-hidden" key={i}>
                      <Card
                        cardType="Heading"
                        img={e?.image1}
                        title={e?.name}
                        click={() => offerClick(e)}
                      />
                    </div>
                  ))
                  .splice(0, 4)}
              {isLoading &&
                [1, 2, 3, 4].map((e, i) => (
                  <div className="px-2 overflow-hidden py-2" key={e}>
                    <Skeleton />
                  </div>
                ))}
            </div>
          </div>
          <div>
            <div>
              <h4 className="mb-0 px-3 font-bold">Free Privileges for You</h4>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 py-3 gap-2">
              {dashboardData.get_privileges &&
                dashboardData.get_privileges
                  .map((e, i) => (
                    <div className="px-2 overflow-hidden" key={e.id}>
                      <Card
                        cardType="Heading"
                        img={e?.image1}
                        title={e?.name}
                        click={() => offerClick(e)}
                      />
                    </div>
                  ))
                  .splice(0, 4)}
              {isLoading &&
                [1, 2, 3].map((e, i) => (
                  <div className="px-2 overflow-hidden py-2" key={e}>
                    <Skeleton />
                  </div>
                ))}
            </div>
          </div>
          <div>
            <div>
              <h4 className="mb-0 px-3 font-bold">Handpicked Offers for You</h4>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 py-3 gap-2">
              {dashboardData?.get_handpicked_offer &&
                dashboardData?.get_handpicked_offer
                  .map((e, i) => (
                    <div className="px-2 overflow-hidden" key={e.id}>
                      <Card
                        cardType="Heading"
                        img={e?.image1}
                        title={e?.name}
                        click={() => offerClick(e)}
                      />
                    </div>
                  ))
                  .splice(0, 4)}
              {isLoading &&
                [1, 2, 3, 4].map((e, i) => (
                  <div className="px-2 overflow-hidden py-2" key={i}>
                    <Skeleton />
                  </div>
                ))}
            </div>
          </div>

          <div>
            <div>
              <h5 className="mb-0 px-3 font-bold">
                Best Discount Across Categories
              </h5>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 py-3 gap-2">
              {dashboardData?.get_across_categories &&
                dashboardData?.get_across_categories
                  .map((e, i) => (
                    <div className="px-2 overflow-hidden" key={e.id}>
                      <Card
                        cardType="Heading"
                        img={e?.image1}
                        title={e?.name}
                        click={() => offerClick(e)}
                      />
                    </div>
                  ))
                  .splice(0, 4)}
              {isLoading &&
                [1, 2, 3, 4].map((e, i) => (
                  <div className="px-2 overflow-hidden py-2" key={i}>
                    <Skeleton />
                  </div>
                ))}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Home;
